// @ts-check

const RouteErrorFallback = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Something went wrong</h1>
    <button
      onClick={() => window.location.reload()}
      style={{
        marginTop: '1rem',
        padding: '0.5rem 1rem',
        cursor: 'pointer',
      }}
    >
      Reload
    </button>
  </div>
);

export default RouteErrorFallback;
